import { SENS_VENTE } from '@/configuration/devisConf';

export default function genererSpecialisation() {
  return {
    modeReglementId: null,
    sens: SENS_VENTE,
    libelleEcriture: null,
    libelleLigneEcritureTiers: null,
    libelleLigneEcritureBanque: null,
    libelleReferenceBanque: null,
    libelleReferenceTiers: null,
    selected: false,
  };
}
